import { createSelector } from "reselect";
import moment from "moment";

export const getScheduleSelector = state => {
  return state.trainer.schedule;
};

export const getScheduleGroupSelector = state => {
  return state.selects.scheduleGroup;
};

export const getChildScheduleSelector = createSelector(
  [getScheduleSelector],
  scheduleChild => {
    moment.locale("ru");
    return {
      ...scheduleChild,
      startTime: moment(scheduleChild.start).format("HH:mm"),
      endTime: moment(scheduleChild.start, "YYYY-mm-dd HH:mm")
        .add(scheduleChild.duration, "minutes")
        .format("HH:mm"),
      dataString: moment(scheduleChild.start).calendar(null, {
        sameDay: "[Сегодня]",
        nextDay: "DD MMMM",
        nextWeek: "DD MMMM",
        lastDay: "DD MMMM",
        lastWeek: "DD MMMM",
        sameElse: "DD MMMM"
      })
    };
  }
);

export const getScheduleGroupForClientSelector = createSelector(
  [getScheduleGroupSelector, (state, child) => child],
  (scheduleGroup, child) => {
    return scheduleGroup
      .filter(o => !child.schedule.find(o2 => o.id === o2.id))
      .sort(function(a, b) {
        return new Date(a.start) - new Date(b.start);
      })
      .map(item => ({
        ...item,
        value: `${moment(item.start).format("DD.MM.YYYY")} ${moment(
          item.start
        ).format("HH:mm")}-${moment(item.start, "YYYY-mm-dd HH:mm")
          .add(item.duration, "minutes")
          .format("HH:mm")}`
      }));
  }
);
